<template>
  <b-card @click="$emit('productSelect', service.productid, disabled)" :body-class="'rounded' + (isActive ? ' outline-' + service.class : '') + (selectedProduct != null && selectedProduct.productid === service.productid ? ' adjustForSelected' : '')" :class="service.class + (selectedProduct != null && selectedProduct.productid === service.productid ? ' selectedOutline' : ' hover-' + service.class) + (disabled ? ' disabled-svc' : '')" v-if="service != null">
    <b-card-header :class="service.class + '-header m-4'">{{ service.name }}</b-card-header>
    <slot name='description'>
        <b-card-text class="m-4" v-if="!disabled">
          {{ service.description }}
          <br />
          {{ service.devices }} devices
          <br />
          Upload {{ service.upDescription }}
          <br />
          Download {{ service.downDescription }}
        </b-card-text>
        <b-card-text class="m-4" v-else>
          Unavailable with current promotion
        </b-card-text>
        <div>
        <span v-if="monthlyPrice != undefined && subscription.product.productid !== service.productid && !disabled" class="m-4">
        {{calculatePriceText()}}{{price.toFixed(2) }}
          <!-- <br /> -->
          <span v-if="!temporary" style="display: inline-block" class="ml-4 mr-4">Monthly cost of £{{ monthlyPrice.toFixed(2) >= 0 ? monthlyPrice.toFixed(2) : 0.00 }}</span>
          <span v-else style="display: inline-block" class="ml-4 mr-4">Monthly cost of £{{monthlyPrice.toFixed(2) >= 0 ? monthlyPrice.toFixed(2) : 0.00}}{{temporary ? ' until ' + $options.filters.dateFormat(new Date(special.availto), 'dddd D MMM YYYY') + ', then revert to full monthly cost of £' + productMonthPrice.toFixed(2) : ''}}</span>
        </span
        >
        <span v-else-if="monthlyPrice != undefined && subscription.product.productid === service.productid && !disabled" class="m-4">Payment is £{{
            monthlyPrice.toFixed(2)
          }}
          <br />
          <span class="m-4">This is your active plan</span>
          <br v-if="disabled" /><br v-if="disabled" /><br v-if="disabled" />
        </span>
        <span v-else-if="disabled" class="m-4">
          <br /><br /><br /><br /><br /><br />
        </span>
        <br />
        </div>
    </slot>
    <slot name='action'>
    </slot>
    
    <b-card-footer v-if="(active || canUpgrade || canDowngrade)" :class="'p-3 product-footer-' + service.class + ' ' + (active ? 'active-product-footer' : '')">
      <span v-if="active">
        <div style="text-align: center;">YOUR CURRENT PLAN</div>
        <div style="text-align: center;">Plan Renews: {{ activeuntil.toDateString() }}</div>
      </span>
      <span v-if="canUpgrade" >
        <div style="text-align: center;">UPGRADE</div>
        <div style="text-align: center;">Boost until: {{ activeuntil.toDateString() }}</div>
      </span>
      <span v-if="canDowngrade" >
        <div style="text-align: center;">DOWNGRADE</div>
        <div style="text-align: center;">Plan would start: {{ activeuntil.toDateString() }}</div>
      </span>
    </b-card-footer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdjustProductCard',
  props: {
    service: {
        type: Object, // name, descripion, class
        required: true
    },
    price: {
        type: Number,
        required: true
    },
    monthlyPrice: {
      type: Number,
      required: true
    },
    productMonthPrice: {
      type: Number,
      required: true
    },
    isActive: {
        type: Boolean,
        default: false
    },
    activeuntil: {
        type: Date,    
    },
    canUpgrade: {
        type: Boolean,
        default: false
    },
    canDowngrade:{
        type: Boolean,
        default: false
    },
    selectedProduct: {
      type: Object,
      default: null
    },
    minimumPrice: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    temporary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: this.isActive,
    }
  },
  computed: {
    ...mapGetters({
      subscription: "plan/getSubscription",
      prices: "pricing/getPrices",
      activeproduct: "plan/getActiveProduct",
      special: "pricing/getSpecial"
    })
  },
  watch: {
    isActive: function() {
      this.$nextTick(() => { this.active = this.isActive})
    }
  },
  methods: {

    calculatePriceText() {
      return this.subscription.product.productid > this.service.productid ? 'Downgrade and pay £' : 'Upgrade for £';
    }

  }
}
</script>

<style lang="scss" scoped>
.svc1 {
  background: linear-gradient(to right, #373b44, #38AADE) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc2 {
  background: linear-gradient(to right, #a1540b, #EE811A) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px !important;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc3 {
  background: linear-gradient(to right, #517043, #5DB12F) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}
.svc4, .svc5 {
  background: linear-gradient(to right, #a08b00 5%, mix(#a08b00, #cdb970, 50%) 20%, #cdb970 40%) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 12px;
  padding: 5px;
  width: 18rem;
  min-width: 18rem;
  max-width: 20rem;
}

.disabled-svc {
  filter: grayscale(50%);
  opacity: 0.6;
}

.svc1-header {
  border: solid white 2px;
  background: linear-gradient(to left, #526797, #3f66ad) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc2-header {
  border: solid white 2px;
  background: linear-gradient(to left, #a75a12, #EE811A) !important;
  border-radius: 14px 14px 14px 14px;
  box-shadow: 12px 10px 8px #373b44;
}

.svc3-header {
  border: solid white 2px;
  background: linear-gradient(to left, #79a560, #5DB12F) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.svc4-header, .svc5-header {
  border: solid white 2px;
  background: linear-gradient(to left, #867a50, #ccba78) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 12px 10px 8px #373b44;
}

.card-body {
  padding: 0 0 0 0 !important;
  border-radius: 20px 20px 20px 20px !important;
  -moz-border-radius: 20px 20px 20px 20px;
  -webkit-border-radius: 20px 20px 20px 20px;
}

.product-footer-svc1 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  -moz-border-radius-topright: 140px 60px !important;
  -webkit-border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  -moz-border-radius-topleft: 140px 60px !important;
  -webkit-border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  -moz-border-radius-bottomleft: 20px !important;
  -webkit-border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  -moz-border-radius-bottomright: 20px !important;
  -webkit-border-bottom-right-radius: 20px !important;
  background: #4972c0;
  border: 1px black solid;
}

.product-footer-svc2 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #EE811A;
  border: 1px black solid;
}

.product-footer-svc3 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #4f9e25;
  border: 1px black solid;
}

.product-footer-svc4, .product-footer-svc5 {
  padding: 0 0 0 0;
  border-top-right-radius: 140px 60px !important;
  border-top-left-radius: 140px 60px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  background: #ccba78;
  border: 1px black solid;
}

.active-product-footer {
  border: solid #551355 4px;
}

.selectedOutline {
  border: yellowgreen 8px solid;
}

.adjustForSelected {
  margin: -7px;
}

</style>